import { render, staticRenderFns } from "./CotationAndTracking.vue?vue&type=template&id=6e2a30e6&scoped=true&"
import script from "./CotationAndTracking.vue?vue&type=script&lang=js&"
export * from "./CotationAndTracking.vue?vue&type=script&lang=js&"
import style0 from "./CotationAndTracking.vue?vue&type=style&index=0&id=6e2a30e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a30e6",
  null
  
)

export default component.exports